import React, { PureComponent } from 'react';

class ServiceStatus extends PureComponent {
  render() {
    return <div className="service_status_layout">ServiceStatus</div>;
  }
}

export default ServiceStatus;
